import { render, staticRenderFns } from "./ResourceDetailsSectionContent.vue?vue&type=template&id=b48fafa4"
import script from "./ResourceDetailsSectionContent.vue?vue&type=script&lang=js"
export * from "./ResourceDetailsSectionContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports